import { RouteComponentProps } from 'react-router-dom';

export function removeTypename(input: any) {
    let output = { ...input};
    if (output.__typename) {
        delete output.__typename;
    }
    return output;
}

export function removeTypenameRecursive(_input: any) {
    let input;
    if (
        _input &&
        typeof _input.slice === 'function'
    ) {
        input = _input.slice();
    } else {
        input = _input;
    }
    
    if (Array.isArray(input)) {
        return input.map(removeTypenameRecursive);
    } else if (typeof input === 'object') {
        let output = { ...input };
        Object.keys(output).forEach(key => {
            if (output[key]) {
                output[key] = removeTypenameRecursive(output[key]);
            } else if (
                output[key] !== false
                && output[key] !== 0
            ) {
                delete output [key];
            }

            if (output[key] === '' ) {
                delete output[key];
            }
        
        });

        if (output.__typename) {
            delete output.__typename;
        }

        return output;
    }

    if (/^\d*$/.test(input)) {
        return Number(input);
    }

    return input;
}

export function getActualClientId <T extends { typedId: string, clientId: string}> (defaults: T[], value: T ) {
    let defaultVal = defaults.filter(o => o.typedId === value.typedId);
    if (defaultVal.length > 0) {
        return defaultVal[0].clientId;
    } else {
        return value.clientId;
    }
}

export  interface RouteParams {
    currentId: string;
    operation: string;
    state: string;
}

export type ContainerProps = RouteComponentProps<RouteParams>;


// WEBPACK FOOTER //
// ./src/shared/typemap.ts